// Static list of country calling codes.
//
// This used to be fetched at runtime from https://restcountries.com, but that
// API now 301-redirects to a different host (files-03.restcountries.com)
// without CORS headers on the redirect response, which browsers refuse to
// follow for cross-origin requests — breaking the phone country-code
// dropdown everywhere it was used. A bundled static list avoids depending on
// a third-party API (which has gone down/changed before) for something that
// rarely changes.
//
// Shape matches what the old fetch-and-map code produced: { code, label, iso }.
export const COUNTRY_CODES = [
  { code: "+93", label: "Afghanistan (+93)", iso: "AF" },
  { code: "+355", label: "Albania (+355)", iso: "AL" },
  { code: "+213", label: "Algeria (+213)", iso: "DZ" },
  { code: "+1", label: "American Samoa (+1)", iso: "AS" },
  { code: "+376", label: "Andorra (+376)", iso: "AD" },
  { code: "+244", label: "Angola (+244)", iso: "AO" },
  { code: "+1", label: "Anguilla (+1)", iso: "AI" },
  { code: "+1", label: "Antigua and Barbuda (+1)", iso: "AG" },
  { code: "+54", label: "Argentina (+54)", iso: "AR" },
  { code: "+374", label: "Armenia (+374)", iso: "AM" },
  { code: "+297", label: "Aruba (+297)", iso: "AW" },
  { code: "+61", label: "Australia (+61)", iso: "AU" },
  { code: "+43", label: "Austria (+43)", iso: "AT" },
  { code: "+994", label: "Azerbaijan (+994)", iso: "AZ" },
  { code: "+1", label: "Bahamas (+1)", iso: "BS" },
  { code: "+973", label: "Bahrain (+973)", iso: "BH" },
  { code: "+880", label: "Bangladesh (+880)", iso: "BD" },
  { code: "+1", label: "Barbados (+1)", iso: "BB" },
  { code: "+375", label: "Belarus (+375)", iso: "BY" },
  { code: "+32", label: "Belgium (+32)", iso: "BE" },
  { code: "+501", label: "Belize (+501)", iso: "BZ" },
  { code: "+229", label: "Benin (+229)", iso: "BJ" },
  { code: "+1", label: "Bermuda (+1)", iso: "BM" },
  { code: "+975", label: "Bhutan (+975)", iso: "BT" },
  { code: "+591", label: "Bolivia (+591)", iso: "BO" },
  { code: "+387", label: "Bosnia and Herzegovina (+387)", iso: "BA" },
  { code: "+267", label: "Botswana (+267)", iso: "BW" },
  { code: "+55", label: "Brazil (+55)", iso: "BR" },
  { code: "+246", label: "British Indian Ocean Territory (+246)", iso: "IO" },
  { code: "+1", label: "British Virgin Islands (+1)", iso: "VG" },
  { code: "+673", label: "Brunei (+673)", iso: "BN" },
  { code: "+359", label: "Bulgaria (+359)", iso: "BG" },
  { code: "+226", label: "Burkina Faso (+226)", iso: "BF" },
  { code: "+257", label: "Burundi (+257)", iso: "BI" },
  { code: "+855", label: "Cambodia (+855)", iso: "KH" },
  { code: "+237", label: "Cameroon (+237)", iso: "CM" },
  { code: "+1", label: "Canada (+1)", iso: "CA" },
  { code: "+238", label: "Cape Verde (+238)", iso: "CV" },
  { code: "+1", label: "Cayman Islands (+1)", iso: "KY" },
  { code: "+236", label: "Central African Republic (+236)", iso: "CF" },
  { code: "+235", label: "Chad (+235)", iso: "TD" },
  { code: "+56", label: "Chile (+56)", iso: "CL" },
  { code: "+86", label: "China (+86)", iso: "CN" },
  { code: "+57", label: "Colombia (+57)", iso: "CO" },
  { code: "+269", label: "Comoros (+269)", iso: "KM" },
  { code: "+243", label: "Congo (DRC) (+243)", iso: "CD" },
  { code: "+242", label: "Congo (Republic) (+242)", iso: "CG" },
  { code: "+682", label: "Cook Islands (+682)", iso: "CK" },
  { code: "+506", label: "Costa Rica (+506)", iso: "CR" },
  { code: "+225", label: "Cote d'Ivoire (+225)", iso: "CI" },
  { code: "+385", label: "Croatia (+385)", iso: "HR" },
  { code: "+53", label: "Cuba (+53)", iso: "CU" },
  { code: "+357", label: "Cyprus (+357)", iso: "CY" },
  { code: "+420", label: "Czech Republic (+420)", iso: "CZ" },
  { code: "+45", label: "Denmark (+45)", iso: "DK" },
  { code: "+253", label: "Djibouti (+253)", iso: "DJ" },
  { code: "+1", label: "Dominica (+1)", iso: "DM" },
  { code: "+1", label: "Dominican Republic (+1)", iso: "DO" },
  { code: "+593", label: "Ecuador (+593)", iso: "EC" },
  { code: "+20", label: "Egypt (+20)", iso: "EG" },
  { code: "+503", label: "El Salvador (+503)", iso: "SV" },
  { code: "+240", label: "Equatorial Guinea (+240)", iso: "GQ" },
  { code: "+291", label: "Eritrea (+291)", iso: "ER" },
  { code: "+372", label: "Estonia (+372)", iso: "EE" },
  { code: "+251", label: "Ethiopia (+251)", iso: "ET" },
  { code: "+500", label: "Falkland Islands (+500)", iso: "FK" },
  { code: "+298", label: "Faroe Islands (+298)", iso: "FO" },
  { code: "+679", label: "Fiji (+679)", iso: "FJ" },
  { code: "+358", label: "Finland (+358)", iso: "FI" },
  { code: "+33", label: "France (+33)", iso: "FR" },
  { code: "+594", label: "French Guiana (+594)", iso: "GF" },
  { code: "+689", label: "French Polynesia (+689)", iso: "PF" },
  { code: "+241", label: "Gabon (+241)", iso: "GA" },
  { code: "+220", label: "Gambia (+220)", iso: "GM" },
  { code: "+995", label: "Georgia (+995)", iso: "GE" },
  { code: "+49", label: "Germany (+49)", iso: "DE" },
  { code: "+233", label: "Ghana (+233)", iso: "GH" },
  { code: "+350", label: "Gibraltar (+350)", iso: "GI" },
  { code: "+30", label: "Greece (+30)", iso: "GR" },
  { code: "+299", label: "Greenland (+299)", iso: "GL" },
  { code: "+1", label: "Grenada (+1)", iso: "GD" },
  { code: "+590", label: "Guadeloupe (+590)", iso: "GP" },
  { code: "+1", label: "Guam (+1)", iso: "GU" },
  { code: "+502", label: "Guatemala (+502)", iso: "GT" },
  { code: "+224", label: "Guinea (+224)", iso: "GN" },
  { code: "+245", label: "Guinea-Bissau (+245)", iso: "GW" },
  { code: "+592", label: "Guyana (+592)", iso: "GY" },
  { code: "+509", label: "Haiti (+509)", iso: "HT" },
  { code: "+504", label: "Honduras (+504)", iso: "HN" },
  { code: "+852", label: "Hong Kong (+852)", iso: "HK" },
  { code: "+36", label: "Hungary (+36)", iso: "HU" },
  { code: "+354", label: "Iceland (+354)", iso: "IS" },
  { code: "+91", label: "India (+91)", iso: "IN" },
  { code: "+62", label: "Indonesia (+62)", iso: "ID" },
  { code: "+98", label: "Iran (+98)", iso: "IR" },
  { code: "+964", label: "Iraq (+964)", iso: "IQ" },
  { code: "+353", label: "Ireland (+353)", iso: "IE" },
  { code: "+972", label: "Israel (+972)", iso: "IL" },
  { code: "+39", label: "Italy (+39)", iso: "IT" },
  { code: "+1", label: "Jamaica (+1)", iso: "JM" },
  { code: "+81", label: "Japan (+81)", iso: "JP" },
  { code: "+962", label: "Jordan (+962)", iso: "JO" },
  { code: "+7", label: "Kazakhstan (+7)", iso: "KZ" },
  { code: "+254", label: "Kenya (+254)", iso: "KE" },
  { code: "+686", label: "Kiribati (+686)", iso: "KI" },
  { code: "+965", label: "Kuwait (+965)", iso: "KW" },
  { code: "+996", label: "Kyrgyzstan (+996)", iso: "KG" },
  { code: "+856", label: "Laos (+856)", iso: "LA" },
  { code: "+371", label: "Latvia (+371)", iso: "LV" },
  { code: "+961", label: "Lebanon (+961)", iso: "LB" },
  { code: "+266", label: "Lesotho (+266)", iso: "LS" },
  { code: "+231", label: "Liberia (+231)", iso: "LR" },
  { code: "+218", label: "Libya (+218)", iso: "LY" },
  { code: "+423", label: "Liechtenstein (+423)", iso: "LI" },
  { code: "+370", label: "Lithuania (+370)", iso: "LT" },
  { code: "+352", label: "Luxembourg (+352)", iso: "LU" },
  { code: "+853", label: "Macau (+853)", iso: "MO" },
  { code: "+389", label: "Macedonia (+389)", iso: "MK" },
  { code: "+261", label: "Madagascar (+261)", iso: "MG" },
  { code: "+265", label: "Malawi (+265)", iso: "MW" },
  { code: "+60", label: "Malaysia (+60)", iso: "MY" },
  { code: "+960", label: "Maldives (+960)", iso: "MV" },
  { code: "+223", label: "Mali (+223)", iso: "ML" },
  { code: "+356", label: "Malta (+356)", iso: "MT" },
  { code: "+692", label: "Marshall Islands (+692)", iso: "MH" },
  { code: "+596", label: "Martinique (+596)", iso: "MQ" },
  { code: "+222", label: "Mauritania (+222)", iso: "MR" },
  { code: "+230", label: "Mauritius (+230)", iso: "MU" },
  { code: "+52", label: "Mexico (+52)", iso: "MX" },
  { code: "+691", label: "Micronesia (+691)", iso: "FM" },
  { code: "+373", label: "Moldova (+373)", iso: "MD" },
  { code: "+377", label: "Monaco (+377)", iso: "MC" },
  { code: "+976", label: "Mongolia (+976)", iso: "MN" },
  { code: "+382", label: "Montenegro (+382)", iso: "ME" },
  { code: "+1", label: "Montserrat (+1)", iso: "MS" },
  { code: "+212", label: "Morocco (+212)", iso: "MA" },
  { code: "+258", label: "Mozambique (+258)", iso: "MZ" },
  { code: "+95", label: "Myanmar (+95)", iso: "MM" },
  { code: "+264", label: "Namibia (+264)", iso: "NA" },
  { code: "+674", label: "Nauru (+674)", iso: "NR" },
  { code: "+977", label: "Nepal (+977)", iso: "NP" },
  { code: "+31", label: "Netherlands (+31)", iso: "NL" },
  { code: "+687", label: "New Caledonia (+687)", iso: "NC" },
  { code: "+64", label: "New Zealand (+64)", iso: "NZ" },
  { code: "+505", label: "Nicaragua (+505)", iso: "NI" },
  { code: "+227", label: "Niger (+227)", iso: "NE" },
  { code: "+234", label: "Nigeria (+234)", iso: "NG" },
  { code: "+683", label: "Niue (+683)", iso: "NU" },
  { code: "+850", label: "North Korea (+850)", iso: "KP" },
  { code: "+1", label: "Northern Mariana Islands (+1)", iso: "MP" },
  { code: "+47", label: "Norway (+47)", iso: "NO" },
  { code: "+968", label: "Oman (+968)", iso: "OM" },
  { code: "+92", label: "Pakistan (+92)", iso: "PK" },
  { code: "+680", label: "Palau (+680)", iso: "PW" },
  { code: "+970", label: "Palestine (+970)", iso: "PS" },
  { code: "+507", label: "Panama (+507)", iso: "PA" },
  { code: "+675", label: "Papua New Guinea (+675)", iso: "PG" },
  { code: "+595", label: "Paraguay (+595)", iso: "PY" },
  { code: "+51", label: "Peru (+51)", iso: "PE" },
  { code: "+63", label: "Philippines (+63)", iso: "PH" },
  { code: "+48", label: "Poland (+48)", iso: "PL" },
  { code: "+351", label: "Portugal (+351)", iso: "PT" },
  { code: "+1", label: "Puerto Rico (+1)", iso: "PR" },
  { code: "+974", label: "Qatar (+974)", iso: "QA" },
  { code: "+262", label: "Reunion (+262)", iso: "RE" },
  { code: "+40", label: "Romania (+40)", iso: "RO" },
  { code: "+7", label: "Russia (+7)", iso: "RU" },
  { code: "+250", label: "Rwanda (+250)", iso: "RW" },
  { code: "+590", label: "Saint Barthelemy (+590)", iso: "BL" },
  { code: "+1", label: "Saint Kitts and Nevis (+1)", iso: "KN" },
  { code: "+1", label: "Saint Lucia (+1)", iso: "LC" },
  { code: "+508", label: "Saint Pierre and Miquelon (+508)", iso: "PM" },
  { code: "+1", label: "Saint Vincent and the Grenadines (+1)", iso: "VC" },
  { code: "+685", label: "Samoa (+685)", iso: "WS" },
  { code: "+378", label: "San Marino (+378)", iso: "SM" },
  { code: "+239", label: "Sao Tome and Principe (+239)", iso: "ST" },
  { code: "+966", label: "Saudi Arabia (+966)", iso: "SA" },
  { code: "+221", label: "Senegal (+221)", iso: "SN" },
  { code: "+381", label: "Serbia (+381)", iso: "RS" },
  { code: "+248", label: "Seychelles (+248)", iso: "SC" },
  { code: "+232", label: "Sierra Leone (+232)", iso: "SL" },
  { code: "+65", label: "Singapore (+65)", iso: "SG" },
  { code: "+421", label: "Slovakia (+421)", iso: "SK" },
  { code: "+386", label: "Slovenia (+386)", iso: "SI" },
  { code: "+677", label: "Solomon Islands (+677)", iso: "SB" },
  { code: "+252", label: "Somalia (+252)", iso: "SO" },
  { code: "+27", label: "South Africa (+27)", iso: "ZA" },
  { code: "+82", label: "South Korea (+82)", iso: "KR" },
  { code: "+211", label: "South Sudan (+211)", iso: "SS" },
  { code: "+34", label: "Spain (+34)", iso: "ES" },
  { code: "+94", label: "Sri Lanka (+94)", iso: "LK" },
  { code: "+249", label: "Sudan (+249)", iso: "SD" },
  { code: "+597", label: "Suriname (+597)", iso: "SR" },
  { code: "+268", label: "Swaziland (+268)", iso: "SZ" },
  { code: "+46", label: "Sweden (+46)", iso: "SE" },
  { code: "+41", label: "Switzerland (+41)", iso: "CH" },
  { code: "+963", label: "Syria (+963)", iso: "SY" },
  { code: "+886", label: "Taiwan (+886)", iso: "TW" },
  { code: "+992", label: "Tajikistan (+992)", iso: "TJ" },
  { code: "+255", label: "Tanzania (+255)", iso: "TZ" },
  { code: "+66", label: "Thailand (+66)", iso: "TH" },
  { code: "+670", label: "Timor-Leste (+670)", iso: "TL" },
  { code: "+228", label: "Togo (+228)", iso: "TG" },
  { code: "+676", label: "Tonga (+676)", iso: "TO" },
  { code: "+1", label: "Trinidad and Tobago (+1)", iso: "TT" },
  { code: "+216", label: "Tunisia (+216)", iso: "TN" },
  { code: "+90", label: "Turkey (+90)", iso: "TR" },
  { code: "+993", label: "Turkmenistan (+993)", iso: "TM" },
  { code: "+1", label: "Turks and Caicos Islands (+1)", iso: "TC" },
  { code: "+688", label: "Tuvalu (+688)", iso: "TV" },
  { code: "+256", label: "Uganda (+256)", iso: "UG" },
  { code: "+380", label: "Ukraine (+380)", iso: "UA" },
  { code: "+971", label: "United Arab Emirates (+971)", iso: "AE" },
  { code: "+44", label: "United Kingdom (+44)", iso: "GB" },
  { code: "+1", label: "United States (+1)", iso: "US" },
  { code: "+598", label: "Uruguay (+598)", iso: "UY" },
  { code: "+998", label: "Uzbekistan (+998)", iso: "UZ" },
  { code: "+678", label: "Vanuatu (+678)", iso: "VU" },
  { code: "+379", label: "Vatican City (+379)", iso: "VA" },
  { code: "+58", label: "Venezuela (+58)", iso: "VE" },
  { code: "+84", label: "Vietnam (+84)", iso: "VN" },
  { code: "+1", label: "Virgin Islands, U.S. (+1)", iso: "VI" },
  { code: "+681", label: "Wallis and Futuna (+681)", iso: "WF" },
  { code: "+967", label: "Yemen (+967)", iso: "YE" },
  { code: "+260", label: "Zambia (+260)", iso: "ZM" },
  { code: "+263", label: "Zimbabwe (+263)", iso: "ZW" },
].sort((a, b) => a.label.localeCompare(b.label));
